export const treatmentAr = {
  "Soins": "علاجات الاسنان",
  "Prothese": "بدلة الأسنان",
  "Soins gencive": "علاجات اللثة",
  "Soins pediatre": "علاجات الأطفال",
  "Soins de bouche": "علاجات الفم",
  "Conservateur": "علاجات المحافظة",
  "Type": "النوع",

  // Server Side 
  "Le traitement deja existe": "The treatment already exists",
  "Le nom du traitement est obligatoire": "إسم العلاج إلزامي",
  "Le type du traitement est obligatoire": "نوع المعالجة إلزامي",
  "Le prix du traitement est obligatoire": "سعر العلاج اجباري",

  "Traitement deja assuré": "العلاج مضمون بالفعل",
  
}